<script setup lang="ts">
import { computed } from 'vue'

const value = defineModel<number | null>('value', {
    required: false,
})

const majorValue = computed(() => {
  if (value?.value === undefined || value?.value === null) {
    return null
  }

  return (value.value / 100)
})

const updateValue = (newValue: number) => {
  value.value = newValue * 100
}
</script>

<template>
  <InputNumber
    :model-value="majorValue"
    mode="currency"
    currency="USD"
    @update:model-value="updateValue"
  />
</template>